export const HUBSPOT_INTEGRATION_MANUAL_URL =
    "https://www.similarweb.com/corp/wp-content/uploads/2026/01/attachment-Similarweb-Hubspot-Integration-Manual-.pdf";

export const SALESFORCE_INTEGRATION_MANUAL_URL =
    "https://www.similarweb.com/corp/wp-content/uploads/2026/01/attachment-Similarweb-Salesforce-Integration-Manual-1-5.pdf";

export const DYNAMICS_INTEGRATION_MANUAL_URL =
    "https://support.similarweb.com/hc/en-us/articles/37551748434973-Dynamics-365-Integration#h_01KXAPTNQJVSHNN7QRSMZ0JPS4";

export const SIGNALS_API_DOCS_URL =
    "https://www.similarweb.com/corp/wp-content/uploads/2026/01/attachment-Signals-APIs-Manual-.pdf";

export const FIND_NEW_COMPANIES_API_GUIDE_URL =
    "https://support.similarweb.com/hc/en-us/articles/35364561776413-Using-The-New-Companies-API";

export const SI_DATA_CREDITS_API_KEYS_URL = "https://account.similarweb.com/data-credits-management?apiKeys=true";

export const TECHNOLOGY_API_URL =
    "https://docs.similarweb.com/api-v5/api-reference/website-analysis-api/website-content/website-technologies";

export const LEAD_ENRICHMENT_MANUAL_URL =
    "https://docs.similarweb.com/api-v5/api-reference/company-analysis-api/lead-enrichment/enrich-website";

export const AI_OUTREACH_API_DOCS_URL =
    "https://docs.similarweb.com/api-v5/api-reference/company-analysis-api/ai-outreach/sales-ai-outreach";

export const CONTACTS_API_URL =
    "https://docs.similarweb.com/api-v5/api-reference/company-analysis-api/contacts/contacts-search";

export const CONTACTS_VIEW_CENTER_URL =
    "https://www.similarweb.com/corp/wp-content/uploads/2026/01/attachment-Contacts-API-Manual-.pdf";

export const SIGNALS_REST_API_DOCS_URL =
    "https://docs.similarweb.com/api-v5/api-reference/company-analysis-api/signals-2";

export const EXTENSION_DOCUMENTATION_URL =
    "https://support.similarweb.com/hc/en-us/articles/29883434953629-Using-Similarweb-Sales-Extension#h_01K3M6H092S667SYG2J7F10MY4";
